import { render } from "./GamePlayFooterComponent.vue?vue&type=template&id=ba3c77b0"
import script from "./GamePlayFooterComponent.vue?vue&type=script&lang=js"
export * from "./GamePlayFooterComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__